import { RootState } from '@redux/hooks';
import { teamsStoreKey } from './teams.const';
import { IAccount } from '@types';

const selectTeamsState = (state: RootState) => state[teamsStoreKey];

export const getTeamsData = (state: RootState): IAccount | null =>
  selectTeamsState(state).data;

export const getTeamsStatus = (state: RootState) =>
  selectTeamsState(state).apiStatus;

export const selectMemberDetails = (state: RootState) =>
  state.teams.memberDetails;
